import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { ProtocolFormData } from "./models/FormData";
import { Protocol } from "./models/Protocol";
import { CloseModalAction } from "./models/Utils";
import {Plot} from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { FertilizerPlan } from "./models/FertilizerPlan";

export default class ProtocolVuexModule extends AbacoVuexModule {
    @State() STORE_curProtocol!: Protocol | null;
    @State({default: "hide-modal"}) STORE_confirmClose!: CloseModalAction;
    @State() STORE_protocolFormData!: ProtocolFormData | null;
    @State({default: []}) STORE_curVarietiesId!: number[];
    @State({default: []}) STORE_selectedPlots!: Plot [];
    @State({default: 1}) STORE_curStep!: number;
    @State() STORE_canViewProtocol!: boolean;
    @State() STORE_canEditProtocol!: boolean;

    @State() curFertilizerPlan!: FertilizerPlan | null;
}
